import React from 'react';
import Card from './Card';
import PatternPreview from './PatternPreview';
import { PatternType, StoredPattern } from '../types/pattern.model';

interface PatternCardProps {
  pattern: StoredPattern;
  patternType: PatternType;
  onClick: () => void;
}

const PatternCard: React.FC<PatternCardProps> = ({ pattern, patternType, onClick }) => (
  <Card onClick={onClick} className="p-1 w-20">
    <PatternPreview pattern={pattern} type={patternType} />
    {pattern.name && <p className="text-xs w-full truncate text-center mt-1">{pattern.name}</p>}
  </Card>
);

export default PatternCard;
